import { PostAddOutlined } from '@material-ui/icons';
import React from 'react';

interface DocumentImagePlaceholderProps {
  uploadedImage: string | null;
  placeholderImageUrl?: string;
  description: string;
}

const DocumentImagePlaceholder = (props: DocumentImagePlaceholderProps) => {
  const { uploadedImage, placeholderImageUrl, description } = props;
  if (uploadedImage?.length)
    return (
      <img
        src={uploadedImage}
        style={{
          width: 'auto',
          height: '100%',
          maxWidth: '100%',
          padding: '16px 0',
        }}
        alt={description}
      />
    );

  if (placeholderImageUrl)
    return (
      <img
        // component="img"
        src={placeholderImageUrl}
        alt={description}
        style={{ height: '60%', width: 'auto', opacity: 0.4 }}
      />
    );
  return <PostAddOutlined style={{ height: 60, width: 60 }} />;
};

export default DocumentImagePlaceholder;



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-upload/v2/DocumentImagePlaceholder.tsx